<app-form-single-select
    [options]="channels$ | async"
    [value]="channelsCurrentValue$ | async"
    (valueChange)="channelValueChange($event)"
    [placeholder]="'ci.common.channels' | translate"
    [canClear]="false"
></app-form-single-select>